<template>
    <div>
        <div class="topcode-wechat-taskItem-item" @click="updateShow">
            <div class="top">
                <div :class="'flex-center-y auto-width-8 state  task-state-'+taskItem.state">{{taskStateDICT}}</div>
            </div>
            <div class="body">
                <CellGroup class="content">
                    <Cell>
                        <h3>{{taskItem.name}}</h3>
                        <p>{{taskItem.remark}}</p>
                        <Icon slot="extra" style="margin: auto" name="delete" size="20" color="red"
                              @click="deleteTask"/>
                    </Cell>
                    <Cell value-class="cell-value" title="勘查时间" :value="taskItem.time"/>
                    <Cell value-class="cell-value" title="勘查结论" :value="taskItem.result"/>
                    <Cell value-class="cell-value" title="勘查照片"/>
                    <!--<img :src="downloadImg + taskItem.image1" style="width: 75px;"/>-->
                    <div
                            style="display:flex;justify-content : space-between;width:78%;margin:auto;margin-top:8px;"
                    >
                        <UploadImage style="margin-left:-15px" :imageList="[taskItem.image1]" :count="1"/>
                        <UploadImage style="margin-left:-15px" :imageList="[taskItem.image2]" :count="1"/>
                        <UploadImage style="margin-left:-15px" :imageList="[taskItem.image3]" :count="1"/>
                        <UploadImage style="margin-left:-15px" :imageList="[taskItem.image4]" :count="1"/>
                    </div>
                </CellGroup>
            </div>
        </div>
    </div>
</template>

<script>
    import {CellGroup, Cell, Icon, Dialog, Popup, NavBar, Field, Button} from "vant"
    import * as DICT from "@/utils/dict"
    import UploadImage from "@/components/UploadImage";
    import {downloadImg} from "@/config"


    export default {
        components: {CellGroup, Cell, Dialog, Icon, Popup, Field, Button, NavBar, UploadImage},
        props: {
            taskItem: {type: Object, required: true}
        },
        data() {
            return {
                downloadImg,
                show: false,
            };
        },
        computed: {
            taskStateDICT() {
                return DICT.getValue('PROSPECT_TASK_ITEM_STATE', this.taskItem.state)
            },
        },
        created() {
        },
        mounted() {
        },
        methods: {
            updateShow() {
                //this.show = true;
                this.$emit('onUpdate',this.taskItem)
            },
            deleteTask(e) {
                e.stopPropagation()
                Dialog.confirm({
                    message: "确定删除吗"
                }).then(() => {
                    this.$toast.loading("正在处理中");
                    this.$http.tokiot.prospect.taskItem.delete({id: this.taskItem.id})
                        .then(res => {
                            this.$toast.clear();
                            if (res) {
                                this.$toast.success("删除成功");
                                this.$emit("onRefresh")
                            }
                        })
                })
            },
        },
        watch: {}
    };
</script>

<style lang="less" scoped>
    .topcode-wechat-taskItem-item {
        width: 100%;
        /*height: 225px;*/
        padding-bottom: 3px;
        margin-bottom: 8px;
        border-radius: 8px;
        border: 1px #cccccc solid;
        /*background: #51c332;*/

        & > .top {
            color: #fff;
            display: flex;
            height: 28px;
            border-radius: 8px 8px 0px 0px;
            background: #7e7e7e;
            & > .state {
                height: 100%;
                /*width: 65px;*/
                border-radius: 8px 0px 0px 0px;
                justify-content: center;
            }
            & > .time {
                height: 100%;
                width: 100%;
                justify-content: flex-end;

            }
        }
        & > .body {
            display: flex;
            & > .right {
                width: 25px;
                color: #1890ff;
                font-size: 20px;
                font-weight: 500;
            }
            & > .content {
                /*padding: 8px;*/
                width: 100%;
                & > .center {
                    padding: 5px;
                    display: flex;
                    /*background: #5cd8bc;*/
                    & > img {
                        width: 60px;
                        height: 60px;
                        background: #cccccc;
                        border-radius: 8px;
                    }
                    & > .name {
                        padding-left: 20px;
                        height: 100%;
                        display: flex;
                        /*background: #7e7e7e;*/
                        flex-direction: column;

                        & > div {
                            line-height: 1.5;

                        }
                    }
                }
                & > .row {
                    display: flex;
                    line-height: 1.5;
                    /*align-items: center;*/
                    & > label {
                        width: 105px;
                        flex-shrink: 0;
                        &::after {
                            margin-left: 2px;
                            content: '：';
                        }
                    }
                    & > span {
                    }
                }
            }
        }
    }
</style>
